import { useContext, useEffect, useState } from "react";
import FullScreenCard from "../../shared/FullScreenCard";
import { fetchGet } from '../../../utils/fetch';
import { transformDate } from '../../../utils/date';
import TableRequest from "../../TableRequest";
import GeneralContext from "../../../context/GeneralContext";

function PendingRequests() {

  const { changeCurrentMenu } = useContext(GeneralContext);

  const [pendingList, setPendingList] = useState([]);

  const prepareList = (list) => {
    const newList = [];
    for (let i = 0; i < list.length; i++) {
      if (list[i].status === 'pending') {
        list[i].request_date = transformDate(list[i].request_date);
        newList.push(list[i]);
      }
    }
    return newList;
  }

  useEffect(() => {
    const getRequestsFunction = async () => {
      const response = await fetchGet('requests');
      if (response.success) {
        const processedList = prepareList(response.list);
        setPendingList(processedList);
      }
    }
    getRequestsFunction();
  }, []);
  //Componente de tabla con controles

  return (
    <FullScreenCard hasBackNavigation={true} backNavigationFunction={changeCurrentMenu} backNavigationTarget={'manage-requests'}>
      <h1>Solicitudes Pendientes</h1>
      {pendingList.map((item) => (
        <div key={item.id}>
          <br />
          <TableRequest data={item} />
          <hr />
        </div>
      ))}
      <br />
    </FullScreenCard>
  )
}

export default PendingRequests